<div class="shortcut-container">
  <span class="shortcut-icon">{{ cmd }}</span>
  @for (shortcut of shortcuts; track trackByIndex($index)) {
    <span class="shortcut-icon">{{ shortcut }}</span>
  }
</div>
